import { parameterize } from '../strings/parameterize';

export const sanitizePathname = (pathname: string) =>
  pathname
    // remove trailing slash
    .replace(/\/$/, '')
    .split('/')
    // parameterize all parts: alphanumeric and hyphens only and all lowercase
    .map(part => parameterize(part))
    .join('/');
